import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import i18n from '@/i18n';

interface ConnectorStatusProps {
  connectorStatus: string | undefined,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Connector-Status',
  props: {
  connectorStatus: null
},
  setup(__props) {

const props = __props;



const status = computed(() => {
  switch (props.connectorStatus) {
    case 'active':
      return {
        icon: 'icon-check-circle-fill',
        color: 'iconSuccess',
        text: i18n.tc('common.words.active'),
      };
    case 'broken':
      return {
        icon: 'icon-error-circle-fill',
        color: 'iconDanger',
        text: i18n.tc('common.words.broken'),
      };
    case 'delayed':
      return {
        icon: 'icon-warning-fill',
        color: 'orange lighten-3',
        text: i18n.tc('common.words.delayed'),
      };
    case 'incomplete':
      return {
        icon: 'icon-warning-fill',
        color: 'orange lighten-3',
        text: i18n.tc('common.words.incomplete'),
      };
    case 'paused':
      return {
        icon: 'icon-pause-circle',
        color: 'grey lighten-3',
        text: i18n.tc('common.words.paused'),
      };
    default:
      return {
        icon: 'icon-circle-fill',
        color: 'grey lighten-3',
        text: i18n.tc('common.words.unknown'),
      };
  }
});

return { __sfc: true,props, status, computed, i18n }
}

})